var _rect, _circle, _rect2, _circle2, _rect3, _circle3, _rect4, _circle4, _rect5, _circle5, _rect6, _circle6, _rect7, _circle7, _rect8, _circle8, _rect9, _circle9, _rect0, _circle0, _rect1, _circle1, _rect10, _circle10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg16(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 56,
    viewBox: "0 0 134 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "#FFBB25"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 4,
    r: 4,
    fill: "#27AE60"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    width: 8,
    height: 8,
    fill: "#FFBB25"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 4,
    r: 4,
    fill: "#27AE60"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    width: 8,
    height: 8,
    fill: "#FFBB25"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 4,
    r: 4,
    fill: "#27AE60"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    width: 8,
    height: 8,
    fill: "#FFBB25"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 4,
    r: 4,
    fill: "#27AE60"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 24,
    width: 8,
    height: 8,
    fill: "#FFBB25"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 28,
    r: 4,
    fill: "#27AE60"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 24,
    width: 8,
    height: 8,
    fill: "#FFBB25"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 28,
    r: 4,
    fill: "#27AE60"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 24,
    width: 8,
    height: 8,
    fill: "#FFBB25"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 28,
    r: 4,
    fill: "#27AE60"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 24,
    width: 8,
    height: 8,
    fill: "#FFBB25"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 28,
    r: 4,
    fill: "#27AE60"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    y: 48,
    width: 8,
    height: 8,
    fill: "#FFBB25"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 52,
    r: 4,
    fill: "#27AE60"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 48,
    width: 8,
    height: 8,
    fill: "#FFBB25"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 52,
    r: 4,
    fill: "#27AE60"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 48,
    width: 8,
    height: 8,
    fill: "#FFBB25"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 52,
    r: 4,
    fill: "#27AE60"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 48,
    width: 8,
    height: 8,
    fill: "#FFBB25"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 52,
    r: 4,
    fill: "#27AE60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg16);
export default __webpack_public_path__ + "static/media/16.de84384673c918e46bc9a0f2e8375016.svg";
export { ForwardRef as ReactComponent };